import { apiRoutes } from 'config/apiRoutes'
import { useQuery } from 'libs/query'
import { useAxiosPrivate } from 'shared/hooks'
import type { CategoriesRes } from 'features/categories/types/categories.types'
import { useContext } from 'react'
import { AuthContext } from 'store'
import { queryKeys } from 'config/queryKeys'
import { getCurrentQuery } from 'utils/getCurrentQuery'

export const useFetchCategories = () => {
	const axiosPrivate = useAxiosPrivate()
	const { auth } = useContext(AuthContext)
	const query = getCurrentQuery()

	const {
		data: categories,
		isPending: isCategoriesLoading,
		isSuccess: isCategoriesSuccess
	} = useQuery<CategoriesRes>({
		queryKey: queryKeys.categories.list(query),
		queryFn: () => axiosPrivate.get(apiRoutes.categories(query ?? '')),
		enabled: !!auth.accessToken
	})

	return {
		categories,
		isCategoriesLoading,
		isCategoriesSuccess
	}
}
